import _ from 'lodash';


const BLOCKS_BIND = 'BlocksBind';
const BLOCKS_QUOTE = 'BlocksQuote';
const BLOCKS_QUOTE_RELEASE = 'BlocksQuoteRelease';
const NON_BLOCKING = 'NonBlocking';

function getBlockedQuotes(uwIssues) {
    const uwIssuesByOffering = getUwIssuesByOffering(uwIssues);
    return Object.keys(uwIssuesByOffering);
}

function getUwIssuesByOffering(uwIssues) {
    return _.groupBy(uwIssues, offeringIssue => offeringIssue.offering);
}

function getBlockingPointDisplayKey(blockingPoint) {
    switch (blockingPoint) {
        case BLOCKS_BIND:
            return 'quoteandbind.directives.MultiQuoteView.Blocks bind';
        case BLOCKS_QUOTE:
            return 'quoteandbind.directives.MultiQuoteView.Blocks quote';
        case BLOCKS_QUOTE_RELEASE:
            return 'quoteandbind.directives.MultiQuoteView.Blocks quote release';
        case NON_BLOCKING:
            return 'quoteandbind.directives.MultiQuoteView.Non-blocking';
        default:
            return blockingPoint;
    }
}

function addDisplayKeysToSingleUwIssue(uwIssue) {
    if (!uwIssue) {
        return uwIssue;
    }

    return Object.assign({}, uwIssue, {
        currentBlockingPointDisplayKey: getBlockingPointDisplayKey(uwIssue.currentBlockingPoint)
    });
}

function addDisplayKeys(uwIssues) {
    if (_.isArray(uwIssues)) {
        return uwIssues.map(addDisplayKeysToSingleUwIssue);
    }
    return addDisplayKeysToSingleUwIssue(uwIssues);
}

export default () => ({
    getBlockedQuotes,
    getUwIssuesByOffering,
    addDisplayKeys
});